import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { WINDOW } from '@ng-web-apis/common';

@Component({
  selector: 'pd-unrecoverable-error',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './unrecoverable-error.component.html',
  styleUrls: ['./unrecoverable-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnrecoverableErrorComponent {
  private snackBarRef = inject(MatSnackBarRef);
  private window = inject(WINDOW);

  reason = inject(MAT_SNACK_BAR_DATA);

  reload() {
    this.window.location.reload();
    this.snackBarRef.dismiss();
  }
}
